const translation = {
  CONTACT_TITLE_H5: 'Contactez-nous',
  CONTACT_TITLE_H2: 'Contactez-moi',
  CONTACT_SUBJECT: 'Sujet',
  CONTACT_NAME: 'Nom complet',
  CONTACT_EMAIL: 'Email',
  CONTACT_MESSAGE: 'Message',
  CONTACT_BTN: 'Envoyer un message',
};

export default translation;
